import { useMemo } from 'react';
import { Module } from 'src/domain';
import { AuditLogEnum } from 'src/infrastructure/rest-api/api-types';
import { useCurrentModule } from '../useCurrentModule';

export const useAuditLogModuleType = (module?: Module, details = false): AuditLogEnum | null => {
    const currentModule = useCurrentModule();
    const moduleToUse = module ?? currentModule;

    // ! FIXME: Could we reuse some typings to prevent this insane mapping function?
    const moduleType: AuditLogEnum | null = useMemo(() => {
        switch (moduleToUse) {
            case Module.Turnover:
                return 'Turnover';
            case Module.CategorySplit:
                return 'CategorySplit';
            case Module.BuyingEventManagement:
                return 'BuyingEvent';
            case Module.DeliveryProfile:
                return 'DeliveryProfile';
            case Module.GenderSplit:
                return 'GenderSplit';
            case Module.Markdown:
                return 'Markdown';
            case Module.Markup:
                return 'Markup';
            case Module.NoosShare:
                return 'NoosShare';
            case Module.OpenToBuyLimit:
                return 'OpenToBuyLimit';
            case Module.ProductLineSplit:
                return 'GenderProductLineSplit';
            case Module.WeekCover:
                return 'WeekCover';
            case Module.StockManagement:
                return 'StockManagement';
            case Module.StyleTimeline:
                return 'StyleTimeline';
            case Module.SalesCampaigns:
                return 'SalesCampaign';
            case Module.SalesCampaignsPlanning:
                if (details) {
                    return 'SalesCampaignDiscount';
                }
                return 'SalesCampaign';
            default:
                return null;
        }
    }, [moduleToUse, details]);

    return moduleType;
};
